module.exports = __webpack_public_path__ + "img/94.91cb21d3.jpg";